/**
 * bulkWaHelpers.js — دوال نقية للإرسال الجماعي عبر واتساب (قابلة للاختبار).
 *
 * لا تلمس منطق الإرسال أو بواباته — هذه مساعدات واجهة فقط:
 *  • pickDefaultAfterLoad: أي قالب افتراضي يُختار *بعد* وصول القائمة.
 *  • humanizeSendError: تحويل رموز الخطأ التقنية إلى عربية واضحة.
 *  • isSendable: بوابة تفعيل زر الإرسال (تعكس شرط disabled — واجهة فقط).
 */

// يُختار القالب الافتراضي فقط إذا وُجد فعلًا ضمن القوالب المحمّلة والمسموحة.
// لو لم يكن للتصنيف افتراضي (want فارغ) أو لم يُطابق خيارًا محمّلًا → "" (لا اختيار).
export function pickDefaultAfterLoad(want, allowedNames) {
  if (!want) return "";
  return (allowedNames || []).includes(want) ? want : "";
}

// رسالة عربية واضحة بدل الرموز التقنية مثل template_not_approved:MISSING.
export function humanizeSendError(raw) {
  if (!raw) return "خطأ غير معروف";
  const s = String(raw);
  if (/(^|:)MISSING$/.test(s) || s.includes("template_not_approved:MISSING")) {
    return "لم تختر قالبًا معتمدًا — اختر قالبًا قبل الإرسال.";
  }
  if (s.startsWith("template_not_approved")) {
    return "القالب غير معتمد من Meta — اختر قالبًا معتمدًا من صندوق القوالب.";
  }
  if (s.includes("kill") || s.includes("blocked")) {
    return "الإرسال متوقّف حاليًا بأمر مفتاح الإيقاف — راجع إعدادات واتساب.";
  }
  return s;
}

// بوابة واجهة: هل يمكن الإرسال؟ (لا إرسال بلا قالب مختار وجاهز ومستلمين وMeta مفعّل)
export function isSendable({ templateName, isReady, selectedCount, metaOn }) {
  return !!templateName && !!isReady && (selectedCount || 0) > 0 && metaOn === true;
}
